export class LoginService {

  static async login(username, password) {
    const apiUrl = process.env.REACT_APP_LOAD_PAGE_URL;
    try {
      const response = await fetch(`${apiUrl}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      throw error;
    }
  }

  static async changePassword({ password }) {
    const apiUrl = process.env.REACT_APP_LOAD_PAGE_URL;
    try {
      const response = await fetch(`${apiUrl}/login/new-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        if (response.status === 403) {
            throw new Error('Unauthorized');
        }
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error changing password:', error);
      throw error;
    }
  }
}
